<template>
  <div class="menu">
    <div class="header">
      <h2 class="heading">{{ __("Menu") }}</h2>
      <a
        href="#"
        :class="['close', lang.dir === 'ltr' ? 'ltr' : '']"
        @click.prevent="close && close()"
      >
        <i-icon name="cancel" />
      </a>
    </div>
    <div class="list">
      <p-vue-menu :model="menuItems" />
    </div>
    <div class="langs">
      <img
        class="israel"
        :class="{ active: lang.code == 'he' }"
        @click="changeLang(1)"
        src="@/assets/img/israel-flag.svg"
        alt="עברית"
        title="עברית"
      />
      <img
        class="uk"
        :class="{ active: lang.code == 'en' }"
        @click="changeLang(2)"
        src="@/assets/img/uk-flag.svg"
        alt="English"
        title="English"
      />
      <img
        class="ru"
        :class="{ active: lang.code == 'en' }"
        @click="changeLang(4)"
        src="@/assets/img/ru-flag.svg"
        alt="Русский"
        title="Русский"
      />
    </div>
  </div>
</template>

<script>
import { __ } from "@/plugins/i18n/";
import { mapState } from "vuex";
import { languages } from "../../../public/local";
import { getWorkerData } from "@/services/service";
import { PrimeIcons } from "primevue/api";

export default {
  props: {
    close: Function,
  },
  data() {
    return {
      list: [
        {
          name: "Buildings List",
          label: __("Buildings List"), // רשימת בניינים
          to: "/",
          icon: PrimeIcons.BUILDING,
          command: () => this.buildings(),
          show: false,
        },
        {
          name: "Service calls",
          label: __("Service calls"), // קריאות שירות
          icon: PrimeIcons.CALENDAR,
          to: { name: "ServiceCalls" },
          show: false,
        },
        {
          name: "Add Service Call",
          label: __("Add Service Call"), // קריאות שירות חדשה
          icon: PrimeIcons.PLUS_CIRCLE,
          to: { name: "AddServiceCalls" },
          show: false,
        },
        {
          name: "Suppliers",
          label: __("Suppliers"), // ספקים
          icon: PrimeIcons.BRIEFCASE,
          to: { name: "Suppliers" },
          show: false,
        },
        {
          name: "Daily Plan",
          label: __("Daily Plan"), // תכנון יומי
          icon: PrimeIcons.SLIDERS_H,
          to: { name: "DailyPlan" },
          show: false,
        },
        {
          name: "MailItems",
          label: __("Mail items List"), // רשימת פרטי דואר
          icon: PrimeIcons.BOX,
          to: { name: "MailItems" },
          show: false,
        },
        {
          name: "Keys",
          label: __("Keys List"), // רשימת מפתחות
          icon: PrimeIcons.KEY,
          to: { name: "Keys" },
          show: false,
        },
        {
          name: "Application Feedback",
          label: __("Application Feedback"), // משוב על האפליקציה
          icon: PrimeIcons.INFO_CIRCLE,
          to: { name: "ApplicationFeedback" },
          show: false,
        },
        {
          name: "Sign out of the system",
          label: __("Sign out of the system"), // יציאה מהמערכת
          icon: PrimeIcons.POWER_OFF,
          command: () => this.logOut(),
          show: false,
        },
        {
          name: "Add to Home Page",
          label: __("Add to Home Page"), // הוספה לדף הבית
          icon: PrimeIcons.HOME,
          command: () => this.addToHomePage(),
          show: false,
        },
      ],
    };
  },
  mounted() {
    this.$store.commit("api/setSessionData", {
      bID: null,
      buildingAddress: null,
    });
    if (!this.openServiceCallsCnt) getWorkerData();
  },
  methods: {
    logOut() {
      this.$store.commit("api/resetToken");
      // VueCookieNext.setCookie("loggedIn", false);
      this.$store.commit("api/setSessionData", {
        loggedIn: false,
        User: { pswd: null, userName: this.userName },
      });
      this.$router.push({ name: "Login" });
    },
    addToHomePage() {
      this.beforeinstallpromptEvent.prompt();
    },
    changeLang(lang) {
      let language = languages.find((l) => +l.id === +lang);
      this.$store.commit("api/setSessionData", {
        languageId: lang,
      });
      this.$store.dispatch("doLanguageSwitch", language);
      this.close();
    },
    buildings() {
      this.$store.commit("api/setSessionData", {
        buildingsSearch: null,
      });
      this.close();
    }
  },
  computed: {
    menuItems() {
      // הצגת התפריט לפי הרשאות - וועד
      let items = this.list;
      this.list.forEach((item) => {
        item.show = true;
        if (item.name == "Service calls")
          item.label =
            __("Service calls") + " (" + this.openServiceCallsCnt + ")";
        if (item.name == "Add to Home Page" && !this.beforeinstallpromptEvent)
          item.show = false;
        if (
          !this.allowReceptionistModule &&
          (item.name == "MailItems" || item.name == "Keys")
        )
          item.show = false;
      });
      return items.filter((f) => f.show == true);
    },
    ...mapState({
      lang: (state) => state.local,
      userName: (state) => state.api.User.userName,
      openServiceCallsCnt: (state) => state.api.openServiceCallsCnt,
      allowReceptionistModule: (state) => state.api.allowReceptionistModule,
      beforeinstallpromptEvent: (state) => state.beforeinstallpromptEvent,
    }),
  },
};
</script>

<style scoped>
.menu {
  display: flex;
  flex-direction: column;

  height: 100vh;
}

.header {
  top: 0;
  z-index: 2;
  position: sticky;
  position: -webkit-sticky;

  margin: 0;
  padding: 20px 20px 20px 0;

  background-color: white;
  border-bottom: 3px solid var(--color-accent);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list {
  /* flex: 1; */

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.heading {
  margin: 0;
  padding: 0;

  font-size: 24px;
  line-height: 0.85;
  font-weight: normal;
  letter-spacing: 0.77px;
  color: var(--color-accent);
}

.close {
  top: 15px;
  position: absolute;
  right: calc(100% - 30px);

  color: var(--color-accent);
}

.close.ltr {
  left: calc(100% - 30px);
}

.close:deep(.svg) {
  width: 21px;
  height: 21px;
}

.menu:deep(.p-menu) {
  width: 100%;
  max-height: 100%;

  overflow-y: auto;

  margin: 0;
  padding: 0;

  border: none;
  border-radius: 0;
}

.menu:deep(.p-menu-list) {
  padding: 0;
}

.menu:deep(.p-menuitem:not(:last-child)::after) {
  content: "";

  display: block;

  width: 100%;
  max-width: calc(100% - 40px);

  margin: 0 20px;

  border-bottom: 1px solid var(--color-border-alt);
}

.menu:deep(.p-menuitem-link) {
  padding: 20px;
}

.menu:deep(.p-menuitem-link .p-menuitem-icon) {
  width: 10px;
  /* height: 11px; */
  /* display: none; */
  margin-left: 10px;
  background-size: auto 100%;
  background-repeat: no-repeat;
  /* background-image: url("../../assets/img/icons/list-item.png"); */
}

.menu:deep(.p-menuitem-link .p-menuitem-text) {
  padding-right: 15px;
}

.langs {
  display: flex;
  gap: 15px;
  justify-content: center;
  padding: 15px;
  border-top: 3px solid var(--color-accent);
}

.langs img {
  cursor: pointer;
  width: 35px;
  transition: 0.5s;
}

.langs img:hover {
  transform: scale(1.3);
}

.langs img:hover .uk,
.langs img.active.uk {
  filter: drop-shadow(0px 0px 3px #d80027);
}
.langs img:hover .ru,
.langs img.active.uk {
  filter: drop-shadow(0px 0px 3px #f3efef);
}

.langs img:hover .israel,
.langs img.active.israel {
  filter: drop-shadow(0px 0px 3px #0052b4);
}

.langs .active {
  width: 40px;
}
</style>
